import { RouteType } from "types/RouteType";
import castingMapRoute from "./CastingMap/castingMap.Route";
// import dailyCompressionRoute from "./DailyCompression/dailyCompression.Route";
import fabricationSequenceRoute from "./FabricationSequence/fabricationSequence.Route";
// import finishingReportRoute from "./FinishingReport/finishingReport.Route";
import productionMonitorRoute from "./ProductionMonitor/productionMonitor.Route";
import productionReportRoute from "./ProductionReport/productionReport.Route";
import panelPlantTrackerRoute from "./PanelPlantTracker/PanelPlantTracker.Route";
import moldEngineerAssignmentRoute from "./MoldEngineerAssignment/MoldEngineerAssignment.Route";
import holdManagementRoute from "./HoldManagement/HoldManagement.Route";
import bomRoute from "../bom/BOM.Route";
import manholeRoute from "./manhole/Manhole.Route";
import trailerLoadBuilderRoute from "./trailer-load-builder/TrailerLoadBuilder.Route";

const productionRoutesList: RouteType[] = [
  ...castingMapRoute,
  // dailyCompressionRoute,
  ...fabricationSequenceRoute,
  // ...finishingReportRoute,
  ...productionMonitorRoute,
  ...productionReportRoute,
  panelPlantTrackerRoute,
  moldEngineerAssignmentRoute,
  holdManagementRoute,
  bomRoute,
  manholeRoute,
  trailerLoadBuilderRoute,
];

export default productionRoutesList;
